
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20px","height":"20px","viewBox":"0 0 20 20","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('plus')]),_c('g',{attrs:{"id":"Page-1","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"plus","fill":"currentColor","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M9.98071825,0.00184367538 C9.8610803,0.0168449028 9.77280456,0.120955541 9.77749559,0.241520364 L9.77749559,9.77048447 L0.255062463,9.77048447 C0.240578589,9.7691198 0.225998625,9.7691198 0.211514751,9.77048447 C0.0832441531,9.78251809 -0.010991221,9.89632845 0.0010341474,10.024687 C0.0130595158,10.1530456 0.126791866,10.2473456 0.255062463,10.235312 L9.77749559,10.235312 L9.77749559,19.7642761 C9.77631102,19.8480928 9.82031758,19.926055 9.89266426,19.9683093 C9.96501097,20.0105636 10.0544891,20.0105636 10.1268359,19.9683093 C10.1991825,19.926055 10.2431891,19.8480928 10.2420045,19.7642761 L10.2420045,10.235312 L19.7644376,10.235312 C19.8481969,10.2364974 19.9261057,10.1924606 19.968331,10.1200643 C20.0105563,10.047668 20.0105563,9.95812846 19.968331,9.88573213 C19.9261057,9.81333582 19.8481969,9.76929909 19.7644376,9.77048447 L10.2420045,9.77048447 L10.2420045,0.241520364 C10.2446722,0.173250461 10.2171893,0.107263505 10.16686,0.0610965963 C10.1165306,0.0149296879 10.0484524,-0.00674107041 9.98071825,0.00184367538 Z","id":"Path"}})])])])
          )
        }
      }
    